// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.returnd-work-order-modal .modal-dialog {
    max-width: 70%;
    margin-top: 5%;
}

.returnd-work-order-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}
.returnd-work-order-modal .modal-dialog .wrapper-modal-header{
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-color4);
}
.returnd-work-order-modal .modal-header-title-section{
    display: flex;
    width: 100%;
    align-items: center;
}
.modal-header-title-section .modal-title{
    font: normal normal bold 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color7);
}

.returnd-work-order-modal .modal-header-title-section span{
    margin-left: 15px;
    font: normal normal 300 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color5);
}

.returnd-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.returnd-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span{
    margin-right: 10px;
}

.returnd-work-order-modal .modal-body{
    max-height: 300px;
    padding-top: 8px;
}
.modal-body .wrapper-modal-body{
    width: 100%;
    height: 100%;
    display: grid;
    grid-row-gap: 15px;
}
.modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group{
    display: grid;
    grid-row-gap: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #CCCCCC;
}

.modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
}


.modal-body .wrapper-modal-body .revart-back-modal-card-item-group{
    grid-template-columns: 1fr;
}


/* -------------- Work Order Device List  -------------- */
#workOrderDeviceListModal .modal-dialog{
    max-width: 30%;
    margin-top: 5%;
}

#workOrderDeviceListModal .modal-dialog .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group{
    display: grid;
    /* grid-template-columns: 0.3fr 2fr 1fr; */
    grid-template-columns: 0.5fr 1fr;
    grid-column-gap: 10px;
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .returnd-work-order-modal .modal-dialog .modal-content {
        padding: 0 21px 20px 21px;
    }
    .returnd-work-order-modal .modal-header-title-section span{
        font: normal normal 300 22px/27px Lato;
        letter-spacing: 0.22px;
    }
    .returnd-work-order-modal .modal-dialog .modal-body{
        max-height: 100%;
    }
    .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group{
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }
    .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group{
        grid-row-gap: 10px;
    }
    .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group .card-item-group{
        display: grid;
        grid-template-columns: 1fr 1fr;
        text-align: start;
    }

    /* -------------- Work Order Device List  -------------- */
    #workOrderDeviceListModal{
        padding: 0;
    }
    #workOrderDeviceListModal .modal-dialog{
        max-width: 100%;
        margin-top: 0;
    }
    #workOrderDeviceListModal .modal-dialog .modal-body{
        min-height: 100px;
    }
    #workOrderDeviceListModal .modal-dialog .modal-content{
        padding: 0 21px 20px 21px;
        position: absolute;
        bottom: 0;
        height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/WorkOrderReturndModal.css"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;;AAGA;IACI,0BAA0B;AAC9B;;;AAGA,0DAA0D;AAC1D;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA,wCAAwC;AACxC;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,sCAAsC;QACtC,sBAAsB;IAC1B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,iBAAiB;IACrB;;IAEA,0DAA0D;IAC1D;QACI,UAAU;IACd;IACA;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,SAAS;QACT,YAAY;IAChB;AACJ","sourcesContent":["\r\n.returnd-work-order-modal .modal-dialog {\r\n    max-width: 70%;\r\n    margin-top: 5%;\r\n}\r\n\r\n.returnd-work-order-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n.returnd-work-order-modal .modal-dialog .wrapper-modal-header{\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n.returnd-work-order-modal .modal-header-title-section{\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n}\r\n.modal-header-title-section .modal-title{\r\n    font: normal normal bold 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.returnd-work-order-modal .modal-header-title-section span{\r\n    margin-left: 15px;\r\n    font: normal normal 300 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color5);\r\n}\r\n\r\n.returnd-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control{\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.returnd-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span{\r\n    margin-right: 10px;\r\n}\r\n\r\n.returnd-work-order-modal .modal-body{\r\n    max-height: 300px;\r\n    padding-top: 8px;\r\n}\r\n.modal-body .wrapper-modal-body{\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-row-gap: 15px;\r\n}\r\n.modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group{\r\n    display: grid;\r\n    grid-row-gap: 20px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px solid #CCCCCC;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group{\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n\r\n.modal-body .wrapper-modal-body .revart-back-modal-card-item-group{\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n\r\n/* -------------- Work Order Device List  -------------- */\r\n#workOrderDeviceListModal .modal-dialog{\r\n    max-width: 30%;\r\n    margin-top: 5%;\r\n}\r\n\r\n#workOrderDeviceListModal .modal-dialog .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group{\r\n    display: grid;\r\n    /* grid-template-columns: 0.3fr 2fr 1fr; */\r\n    grid-template-columns: 0.5fr 1fr;\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .returnd-work-order-modal .modal-dialog .modal-content {\r\n        padding: 0 21px 20px 21px;\r\n    }\r\n    .returnd-work-order-modal .modal-header-title-section span{\r\n        font: normal normal 300 22px/27px Lato;\r\n        letter-spacing: 0.22px;\r\n    }\r\n    .returnd-work-order-modal .modal-dialog .modal-body{\r\n        max-height: 100%;\r\n    }\r\n    .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group{\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n    .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group{\r\n        grid-row-gap: 10px;\r\n    }\r\n    .modal-body .wrapper-modal-body .returnd-work-order-modal-card-item-group .returnd-work-order-modal-card-item-inner-group .card-item-group{\r\n        display: grid;\r\n        grid-template-columns: 1fr 1fr;\r\n        text-align: start;\r\n    }\r\n\r\n    /* -------------- Work Order Device List  -------------- */\r\n    #workOrderDeviceListModal{\r\n        padding: 0;\r\n    }\r\n    #workOrderDeviceListModal .modal-dialog{\r\n        max-width: 100%;\r\n        margin-top: 0;\r\n    }\r\n    #workOrderDeviceListModal .modal-dialog .modal-body{\r\n        min-height: 100px;\r\n    }\r\n    #workOrderDeviceListModal .modal-dialog .modal-content{\r\n        padding: 0 21px 20px 21px;\r\n        position: absolute;\r\n        bottom: 0;\r\n        height: auto;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
